(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rubnic-shop-by-brand"] && !Shopify.designMode) return;
  try {
    
(()=>{
  function init(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    const input=root.querySelector('[data-rb-search]'),tools=root.querySelector('[data-rb-tools]');if(!input)return;
    if(tools)tools.hidden=false;
    const items=[...root.querySelectorAll('[data-rb-brand]')],more=root.querySelector('[data-rb-more]'),first=root.querySelector('[data-rb-first]'),count=root.querySelector('[data-rb-count]'),empty=root.querySelector('[data-rb-empty]');
    const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[’']/g,'');
    let wasOpen=false;
    input.addEventListener('input',()=>{
      const query=normalize(input.value.trim());let total=0;
      items.forEach(item=>{item.hidden=!normalize(item.dataset.brandSearch).includes(query);if(!item.hidden)total++;});
      first.hidden=![...first.children].some(x=>!x.hidden);
      if(more){if(query&&!more.dataset.filtering){wasOpen=more.open;more.dataset.filtering='true';}if(query)more.open=true;else if(more.dataset.filtering){more.open=wasOpen;delete more.dataset.filtering;}more.hidden=![...more.querySelectorAll('[data-rb-brand]')].some(x=>!x.hidden);}
      count.textContent=root.dataset.countTemplate.replace('[count]',String(total));empty.hidden=total!==0;
    });
    root.querySelectorAll('img').forEach(img=>img.addEventListener('error',()=>{const card=img.closest('[data-rb-brand]');img.closest('.rb-brand__visual').hidden=true;card.classList.add('rb-brand--text');},{once:true}));
  }
  document.querySelectorAll('[data-rb-brands]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-rb-brands]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
